// Card de "Marco dice" para la sección de Cardio. Vive ARRIBA del aro
// (CardioGoalCard) para igualar el patrón de la sección de Nutrición,
// donde `CoachStreakCard` aparece arriba del aro de calorías.
//
// Antes esta card solo aparecía dentro de `CardioHistorySection`, varias
// pantallas debajo del título "Cardio · Meta Diaria de Quema". El
// cliente entraba a Cardio y veía un aro frío sin el mensaje del coach.
// Ahora le da la bienvenida y refuerza la racha en cuanto entra.

import { CoachStreakCard } from './CoachStreakCard';
import { useCardioStreak } from '@/hooks/useCardioStreak';

interface Props {
  userId: string | null | undefined;
  profileName: string;
  /** Para refetch cuando el cliente registra cardio sin recargar la app. */
  refreshKey?: number;
}

export function CardioCoachCard({ userId, profileName, refreshKey }: Props) {
  const { streak, loggedToday, loading } = useCardioStreak(userId, profileName, refreshKey);
  if (loading || !userId) return null;
  return (
    <CoachStreakCard
      streak={streak}
      activity="cardio"
      clientId={userId}
      clientFirstName={profileName}
      loggedToday={loggedToday}
    />
  );
}
